import React from "react";
import { useState } from "react";
import {
    Dialog, DialogContent, DialogContentText, DialogTitle,
    IconButton, Box, Grid, Typography, TextField, Button, DialogActions
} from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import { MdDeleteOutline } from "react-icons/md";
import CustomButton from "components/Button";

import { useDeleteProjectMutation } from "store/slices/apis/projectApiSlice";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import { useDispatch } from "store";


const DeletePopup = ({ open, onClose, data }) => {
    const dispatch = useDispatch();
    const [deleteProject,] = useDeleteProjectMutation();
    const [isDeleting, setIsDeleting] = useState(false);

    const openNotification = (msg, type = "error", duration = 6000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: "alert",
                alert: { color: type, variant: "filled" },
                transition: "SlideUp",
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };




    const handleConfirmationDelete = async () => {
        if (isDeleting) return;

        setIsDeleting(true);

        const id = data.projectId;

        try {
            const res = await deleteProject(id).unwrap();

            if (res.status === 'Success') {
                openNotification(res.message || "Project Deleted successfully!", "success");
                onClose();
            } else {
                openNotification(res.message || "Something went wrong while deleting the project.", "error");
            }
        } catch (err) {
            console.error("Error deleting project:", err);
            openNotification(err?.data?.message || "Failed to delete project. Please try again.", "error");
        } finally {
            setIsDeleting(false);
            onClose()
        }
    };

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    // handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
            }}><Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                    Delete Project
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ padding: '24px !important' }}>
                <DialogContentText sx={{ fontWeight: 400, fontSize: '16px', color: '#474747', fontFamily: "Outfit, sans-serif" }}>
                    Are you sure you want to Delete this Project.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <CustomButton
                    label="Delete"
                    startIcon={<MdDeleteOutline />}
                    disabled={isDeleting}
                    onClick={handleConfirmationDelete}
                    sx={{
                        backgroundColor: "#00344C",
                        fontFamily: 'Outfit',
                        fontWeight: 500,
                        fontSize: '14px',
                        lineHeight: '100%',
                        letterSpacing: '0px',
                    }}
                />
            </DialogActions>
        </Dialog>
    )
}
export default DeletePopup;